import { SVGProps } from "react";

const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.75 5.75C0.75 5.75 5.22715 0.75 10.75 0.75C16.2728 0.75 20.75 5.75 20.75 5.75"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M20.294 10.795C20.598 11.2213 20.75 11.4345 20.75 11.75C20.75 12.0655 20.598 12.2787 20.294 12.705C18.9279 14.6206 15.4392 18.75 10.75 18.75C6.06078 18.75 2.5721 14.6206 1.20604 12.705C0.902014 12.2787 0.75 12.0655 0.75 11.75C0.75 11.4345 0.902013 11.2213 1.20604 10.795C2.5721 8.87944 6.06078 4.75 10.75 4.75C15.4392 4.75 18.9279 8.87944 20.294 10.795Z"
      stroke="#626262"
      stroke-width="1.5"
    />
    <path
      d="M13.75 11.75C13.75 10.0931 12.4069 8.75 10.75 8.75C9.09315 8.75 7.75 10.0931 7.75 11.75C7.75 13.4069 9.09315 14.75 10.75 14.75C12.4069 14.75 13.75 13.4069 13.75 11.75Z"
      stroke="#626262"
      stroke-width="1.5"
    />
  </svg>
);
export default Eye;
